/* eslint-disable */

export default {
  name: "BolideLoader",

  mounted() {
    const video = document.getElementById('bolide-loader-video');
    if (video) {
      // Get URL from CSS variable: url("...")
      let videoUrl = getComputedStyle(document.documentElement)
        .getPropertyValue('--bolide-loader-video')
        .trim();
      
      // Strip url("") wrapper if present
      if (videoUrl.startsWith('url(')) {
        videoUrl = videoUrl.slice(4, -1).replace(/['"]/g, '');
      }
      
      if (videoUrl) {
        video.src = videoUrl;
      }
    }
  },

  beforeUnmount() {
    // No specific cleanup needed for video element that is unmounted by Vue
  }
};
